<template>
  <!-- 通用调研项目 -->
  <research></research>
</template>

<script>
import research from '@views/research.vue'
export default {
  components: {
    research
  }
}
</script>
